import { Image as AntdImage, ImageProps as AntdImageProps } from "antd";
import React, { FC } from "react";

export interface ImageProps extends AntdImageProps {
  /** Custom border color for the image */
  borderColor?: string;
  /** Custom border radius for the image */
  borderRadius?: string | number;
}

// Type for component that includes Antd Image static members (PreviewGroup)
type ExtendedImageComponent = FC<ImageProps> & {
  PreviewGroup: typeof AntdImage.PreviewGroup;
};

const Image: ExtendedImageComponent = ({
  borderColor = "#edf0f5",
  borderRadius = "0px",
  style,
  ...props
}: ImageProps) => {
  return (
    <AntdImage
      style={{
        ...style,
        border: `2px solid ${borderColor}`,
        borderRadius: borderRadius,
      }}
      {...props}
    />
  );
};
export default Image;

Image.PreviewGroup = AntdImage.PreviewGroup;
